import React, { Suspense, useEffect } from 'react';

import { AppRoutes } from 'app/routes';
import { Loader, NotifyComponent } from 'components';
import './App.scss';
import { LsKeys, NotifyType, Roles } from 'enums';
import { useHandleNotification, useTypedDispatch } from 'hooks';
import { fetchCurrentUser } from 'state';
import { restoreState } from 'utils';

export const App = () => {
  const notification = useHandleNotification();
  const dispatch = useTypedDispatch();

  useEffect(() => {
    const userInfo = restoreState(LsKeys.USER_INFO);

    if (userInfo?.role === Roles.SUPER_ADMIN || !!userInfo?.company) return;

    dispatch(fetchCurrentUser());
  }, []);

  return (
    <Suspense fallback={<Loader />}>
      {notification && (
        <NotifyComponent message={notification} type={NotifyType.SUCCESS} />
      )}
      <AppRoutes />
    </Suspense>
  );
};
